import type { ReactNode } from 'react'
import { useEffect } from 'react'
import { useLocation } from '#router'
import { useFeatureFlag } from '@/hooks/use-feature-flag'
import { AUDITION_INTAKE_CLOSED } from '@/lib/audition/intake'
import { AUDITION_WIZARD_FLAG } from '@/lib/feature-flags'
import LoadingFallback from '../loading-fallback'
import { IntakeClosed } from './intake-closed'

/**
 * Wind-down takes precedence over flags and admin previews. Keep the old
 * wizard available only for an explicit code rollback, never a flag change.
 */
export function ApplyRoute({ children }: { children: ReactNode }) {
  if (AUDITION_INTAKE_CLOSED) return <IntakeClosed />
  return <OpenApplyRoute>{children}</OpenApplyRoute>
}

function OpenApplyRoute({ children }: { children: ReactNode }) {
  const { enabled, isLoaded } = useFeatureFlag(AUDITION_WIZARD_FLAG)
  const { navigate } = useLocation()

  useEffect(() => {
    if (isLoaded && !enabled) {
      navigate('/', { replace: true })
    }
  }, [isLoaded, enabled, navigate])

  if (!isLoaded || !enabled) {
    return <LoadingFallback />
  }

  return <>{children}</>
}
